// Set webpack public path. Use environment variable set in service/src/php/head.php
__webpack_public_path__ = window.EfConfig.javaScriptDirectoryPath || 'assets/js/';

import Ui from './Ui.mjs';
import Landingpage from './Landingpage.mjs'

/*
 * Initialize UI
 */
new Ui();
new Landingpage();